import { CommonModule } from '@angular/common';
import { isDevMode, NgModule } from '@angular/core';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { AuthStoreModule } from './auth-store/auth-store.module';
import { HorsesStoreModule } from './horses-store/horses-store.module';
import { UserStoreModule } from './user-store/user-store.module';
import { UserGroupStoreModule } from './user-group-store/user-group-store.module';
import { CommonStoreModule } from './common-store/common-store.module';
import { IssueStoreModule } from './issue-store/issue-store.module';
import { TagStoreModule } from './tag-store/tag-store.module';
import { AnalysisStoreModule } from './analysis-store/analysis-store.module';
import { AnnotationsStoreModule } from './annotations-store/annotations-store.module';
import { RecordingsStoreModule } from './recordings-store/recordings-store.module';
import { ReviewerInteractionStoreModule } from './reviewer-interaction-store/reviewer-interaction-store.module';
import { StrideReviewStoreModule } from './stride-review-store/stride-review-store.module';
import { ReviewStoreModule } from './review-store/review-store.module';
import { HorsesShareStoreModule } from './horses-share-store/horses-share-store.module';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { clearState, reducers } from './index';
import { AuthEffects } from './auth-store/effects/auth.effects';
import { HorsesEffects } from './horses-store/effects/horses.effects';
import { AnalysisEffects } from './analysis-store/effects/analysis.effects';
import { AnnotationsEffects } from './annotations-store/effects/annotations.effects';
import { UserEffects } from './user-store/effects/user.effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { CustomRouterStateSerializer } from './router-store/custom-route-serializer';
import { AnalysisResultsTextModule } from './analysis-results-text-store/analysis-results-text.module';
import { SharedAnalysisResultsModule } from './shared-analysis-results/shared-analysis-results.module';
import { AsymmetryVariableRangesModule } from './asymmetry-variable-ranges-store/asymmetry-variable-ranges.module';
import { AnalysisStridesStoreModule } from './analysis-strides-store';
import { TransaltionsStoreModule } from './transaltions-store/transaltions-store.module';
import { EventsStoreModule } from './events-store/events-store.module';
import { GuideStoreModule } from './guide-store/guide-store.module';
import { StripePriceProductsStoreModule } from './stripe-price-products-store/stripe-price-products-store.module';
import { InstancesStoreModule } from './instances/instances-store.module';
import { NotificationsStoreModule } from './notifications-store/notifications-store.module';

@NgModule({
  declarations: [],
  exports: [
    AnalysisStoreModule,
    AnnotationsStoreModule,
    AuthStoreModule,
    HorsesStoreModule,
    UserStoreModule,
    UserGroupStoreModule,
    CommonStoreModule,
    IssueStoreModule,
    TagStoreModule,
    RecordingsStoreModule,
    ReviewerInteractionStoreModule,
    StrideReviewStoreModule,
    ReviewStoreModule,
    HorsesShareStoreModule,
    CommonModule,
    AnalysisResultsTextModule,
    AsymmetryVariableRangesModule,
    AnalysisStridesStoreModule,
    TransaltionsStoreModule,
    EventsStoreModule,
    GuideStoreModule,
    StripePriceProductsStoreModule,
    InstancesStoreModule,
    NotificationsStoreModule,
  ],
  imports: [
    AnalysisStoreModule,
    AnnotationsStoreModule,
    AuthStoreModule,
    HorsesStoreModule,
    UserStoreModule,
    UserGroupStoreModule,
    CommonStoreModule,
    IssueStoreModule,
    TagStoreModule,
    RecordingsStoreModule,
    ReviewerInteractionStoreModule,
    StrideReviewStoreModule,
    ReviewStoreModule,
    HorsesShareStoreModule,
    CommonModule,
    AnalysisResultsTextModule,
    SharedAnalysisResultsModule,
    AsymmetryVariableRangesModule,
    AnalysisStridesStoreModule,
    TransaltionsStoreModule,
    EventsStoreModule,
    GuideStoreModule,
    StripePriceProductsStoreModule,
    InstancesStoreModule,
    NotificationsStoreModule,
    StoreModule.forRoot(reducers, {
      metaReducers: [clearState],
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true,
      },
    }),
    StoreDevtoolsModule.instrument({
      maxAge: 40,
      logOnly: !isDevMode(),
      connectInZone: true,
    }),
    EffectsModule.forRoot([]),
    EffectsModule.forFeature([
      AuthEffects,
      HorsesEffects,
      AnalysisEffects,
      AnnotationsEffects,
      UserEffects,
    ]),
    StoreRouterConnectingModule.forRoot({
      serializer: CustomRouterStateSerializer as any,
    }),
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class RootStoreModule {}
